import SubjectCreate from './create';
import SubjectList from './list';
import SubjectShow from './show';
import SubjectEdit from './edit';

export default {
    create: SubjectCreate,
    list: SubjectList,
    show: SubjectShow,
    edit: SubjectEdit
};